// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"SkillSection_checkmark__3BGKo","mobileShowLess":"SkillSection_mobileShowLess__IrGSy"};